import { render } from "./DescriptionNews.vue?vue&type=template&id=0ba4e5c0&scoped=true"
import script from "./DescriptionNews.vue?vue&type=script&lang=js"
export * from "./DescriptionNews.vue?vue&type=script&lang=js"

import "./DescriptionNews.vue?vue&type=style&index=0&id=0ba4e5c0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba4e5c0"]])

export default __exports__